import gql from 'graphql-tag'
import createMutation from 'legacy/apollo/createMutation'
import { type DateString } from 'legacy/common/types'

const mutation = gql`
  mutation ($recurringShiftId: ID!, $deleteShiftsFromDate: Date!) {
    recurringShiftDestroy(
      recurringShiftId: $recurringShiftId
      deleteShiftsFromDate: $deleteShiftsFromDate
    ) {
      deletedRecurringShiftId
    }
  }
`

interface Data {
  recurringShiftDestroy: {
    deletedRecurringShiftId: string
  }
}

interface Variables {
  recurringShiftId: string
  deleteShiftsFromDate: DateString
}

export default createMutation<Data, Variables>(mutation)
